export default {
  placeholder: 'Szukaj marki...',
};
